import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PedidoCanceladoComponent } from './modulos/detalhes/pedido-cancelado/pedido-cancelado.component';
import { PedidoEnviadoComponent } from './modulos/criar-editar/pedido-enviado/pedido-enviado.component';

const routes: Routes = [
    {
        path: '',
        loadChildren: () => import('./modulos/listar/listar.module').then(m => m.ListarModule)
    },
    {
        path: 'editar/:pedidoId',
        loadChildren: () => import('./modulos/criar-editar/criar-editar.module').then(m => m.CriarEditarModule)
    },
    {
        path: 'novo',
        loadChildren: () => import('./modulos/criar-editar/criar-editar.module').then(m => m.CriarEditarModule)
    },
    {
        path: ':pedidoId/detalhes',
        loadChildren: () => import('./modulos/detalhes/detalhes.module').then(m => m.DetalhesModule)
    },
    {
        path: ':pedidoId/revisao',
        loadChildren: () => import('./modulos/revisao/revisao.module').then(m => m.RevisaoModule)
    },
    {
        path: 'cancelado',
        component: PedidoCanceladoComponent
    }
]

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PedidosRoutingModule { }